import request from '@/sheep/request';

const OperationUserApi = {
  getUserHasBoundMobile: async () => {
    return request({
      url: '/operation/user/has-bound-mobile',
      method: 'GET',
      custom: {
        showLoading: false,
        showError: false,
      },
    });
  },
  updateMobile: async (data) => {
    return request({
      url: '/operation/user/update-mobile',
      method: 'PUT',
      data,
      custom: {
        showLoading: true,
        showError: true,
      },
    });
  },
  // 是否分分销员
  hasBoundDistributor: async () => {
    return request({
      url: '/operation/user/has-bound-distributor',
      method: 'GET',
      custom: {
        showLoading: false,
        showError: false,
      },
    });
  },
};

export default OperationUserApi;
